import React from 'react';
import OrderSettings from './OrderSettings';
import PurchaseSubHeader from './PurchaseSubHeader';
import { LongSteelMvp } from './LongSteelMvp';
import useIsCommerceUser from '../../../hooks/useIsCommerceUser';

const LongSteel: React.FC = () => {
  const isCommerceUser = useIsCommerceUser();

  if (isCommerceUser) {
    return <LongSteelMvp />;
  }

  return (
    <>
      <PurchaseSubHeader />
      <OrderSettings />
    </>
  );
};

export default LongSteel;
